<template>
  <div>
    <div class="m-2">
      <h1 class="text-xl text-center font-bold">{{ videoInfo.title }}</h1>
      <p class="mt-1 text-sm text-yx7e7f80 text-center">
        {{ videoInfo.created_at }}
      </p>
      <p v-if="videoInfo && videoInfo.tts_url" class="text-center text-blue-500 mt-1" @click="onClickAudioText">
        <van-icon name="audio" style="font-size: 1.1rem"/>
        <span>{{ videoInfo.click_num }}人听过<strong class="ml-2">点击播放音频</strong></span>
      </p>
      <div v-html="videoInfo.article" id="containerid" class="container1"></div>
      <div class="h-10"></div>

      <div v-if="videoInfo && videoInfo.tts_url" class="audio-control">
        <van-popup v-model="audioControlDisplay" :lazy-render="false" :style="{ height: isIos ? '90%' : '80%' }" closeable position="bottom" @close="onPopupClose">
          <AudioPanel ref="audioPanelRef" :audio_url="videoInfo.tts_url" :flag="audioPlaying" :name="videoInfo.teacher_name" :pic="videoInfo.teacher_img_small_arr[this.device]" :title="videoInfo.title" @on-play-status-change="setAudioPlaying"></AudioPanel>
        </van-popup>
      </div>
      <div v-if="videoInfo && videoInfo.tts_url" class="audio-window-control drag-parent" :style="{'bottom': isIos ? '5rem' : '0'}">
        <AudioWindow ref="audioWindowRef" :pic="videoInfo.teacher_img_small_arr[this.device]" :playStatus="audioPlaying" @change="onAudioWindowChange" @click="onAudioWindowClick" @stop="onAudioWindowStop"></AudioWindow>
      </div>
    </div>
  </div>
</template>
<script>
import { Watermark } from "@pansy/watermark";
import { Toast, Dialog } from "vant";
import AudioPanel from "@/components/audio/AudioPanel.vue";
import AudioWindow from "@/components/audio/AudioWindow.vue";

export default {
  name: "article1",
  components: {AudioPanel,AudioWindow },
  data() {
    return {
      videoInfo: {},
      userInfo: {},
      video_id: 0,
      audioControlDisplay: false,
      initAudioControl: false,
      audioPlaying: false,
      isIos: false,
      device: ""
    };
  },
  created() {
    window.$bus.$on("pauseAudio", () => {
      this.$refs.audioPanelRef.stopPlay();
    })
  },
  mounted() {
    this.device = localStorage.getItem("device") || "mp";
    this.video_id = this.$route.query.video_id;
    this.getUserInfo();
    this.getVideoInfo();
    this.isIos = localStorage.getItem("device") === 'ios';
  },
  beforeDestroy() {
    window.$bus.$off("pauseAudio");
    this.$refs.audioPanelRef.stopPlay();
  },
  methods: {
    setAudioPlaying(status) {
      this.audioPlaying = status;
    },
    onPopupClose() {
      if(this.$refs.audioPanelRef.isOver) {
        this.$refs.audioWindowRef.hidden();
      } else {
        this.$refs.audioWindowRef.show();
      }
    },
    onClickAudioText() {
      this.audioControlDisplay = true;
      this.$refs.audioPanelRef.play();
    },
    onAudioWindowStop() {
      this.$refs.audioPanelRef.stopPlay();
    },
    onAudioWindowChange(status) {
      this.setAudioPlaying(status);
      this.$refs.audioPanelRef.getPlay();
    },
    onAudioWindowClick() {
      this.audioControlDisplay = true;
      this.$refs.audioWindowRef.hidden();
    },
    async getVideoInfo() {
      let videoRes = await this.$axios.get("/video/checkVideoService", {
        params: { video_id: this.video_id },
      });
      const uniapp = localStorage.getItem("uniapp") || null;
      if (videoRes.code == 10001) {
        this.videoInfo = videoRes.data.video_info;
        const watermark = new Watermark({
          text: this.userInfo.name,
          container: "containerid",
          zIndex: 9999,
          fontColor: "#000",
          pack: true,
        });
        process.nextTick(() => {
          watermark.show();
        });
      } else if (videoRes.code == 10002) {
        let nowDevice = localStorage.getItem("device");
        Dialog.alert({
          title: "提醒",
          message: videoRes.msg,
        }).then(() => {
          // on close
          // Toast.fail(nowDevice)
          if (nowDevice == "ios") {
            if(uniapp) {
              uni && uni.postMessage({data: {
                  jump_type: 0,
                  jump_url: "",
                }});
            }else {
              window.webkit.messageHandlers.jsToOcWithPrams.postMessage({
                jump_type: 0,
                jump_url: "",
              });
            }
          } else if (nowDevice == "android" || nowDevice == "ard" || nowDevice === "pad") {
            window.android.jsCallAndroidArgs(`{jump_type: 0, jump_url: '0'}`);
          }
        });
      } else if (videoRes.code == 10014) {
        let nowDevice = localStorage.getItem("device");
        Dialog.alert({
          title: "提醒",
          message: videoRes.msg,
        }).then(() => {
          // on close
          // Toast.fail(nowDevice)
          if (nowDevice == "ios") {
            if(uniapp) {
              uni && uni.postMessage({data: {
                  jump_type: 0,
                  jump_url: "",
                }});
            }else {
              window.webkit.messageHandlers.jsToOcWithPrams.postMessage({
                jump_type: 0,
                jump_url: "",
              });
            }
          } else if (nowDevice == "android" || nowDevice == "ard" || nowDevice === "pad") {
            window.android.jsCallAndroidArgs(
              `{jump_type: 5, jump_url: ${videoRes.data.course_id}}`
            );
          }
        });
      }
    },
    async getUserInfo() {
      let userRes = await this.$axios.get("/user/getUserInfo");
      if (userRes.code == 10001) {
        this.userInfo = userRes.data;
      } else {
        Toast(userRes.msg);
      }
    },
  },
};
</script>
<style>
.mt-1 {
  margin-top: 0.25rem /* 4px */;
}
.text-sm {
  font-size: 0.875rem /* 14px */;
  line-height: 1.25rem /* 20px */;
}
.text-yx7e7f80 {
  --tw-text-opacity: 1;
  color: rgba(126, 127, 128, var(--tw-text-opacity));
}
.text-center {
  text-align: center;
}
.m-2 {
  margin: 0.5rem /* 8px */;
}
.font-bold {
  font-weight: 700;
}
.text-center {
  text-align: center;
}
.text-xl {
  font-size: 1.25rem /* 20px */;
  line-height: 1.75rem /* 28px */;
}
.h-10 {
  height: 2.5rem /* 40px */;
}
.container1 p {
  font-size: 1.15rem;
  margin: 1rem 0;
  /* background-color: white; */
  line-height: 2rem;
  letter-spacing: 0.2rem;
}

.drag-parent {
  position: fixed;
  top: 11rem;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: none;
  pointer-events: none
}

.van-popup {
  z-index: 99999999 !important;
}
</style>
